var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 105 105",
    fill: "#e9408f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "0s",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 52.5,
    r: 12.5,
    fillOpacity: 0.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "100ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 12.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "300ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 52.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "600ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 12.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "800ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 52.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "400ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 92.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "700ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 52.5,
    cy: 92.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "500ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 92.5,
    r: 12.5
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "fill-opacity",
    begin: "200ms",
    calcMode: "linear",
    dur: "1s",
    repeatCount: "indefinite",
    values: "1;.2;1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.40b83f1a3eb52353877878d740990eda.svg";
export { ForwardRef as ReactComponent };